<ion-app>

  <ion-split-pane disabled="true" contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-header>
        <ion-toolbar>
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <ion-list>
          @for (p of appPages; track p; let i = $index) {
            <ion-menu-toggle auto-hide="false">
              <ion-item (click)="selectedIndex = i" routerDirection="root" [routerLink]="[p.url]" [state]="p.params" lines="none" detail="false" [class.selected]="selectedIndex == i">
                <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          <ion-item lines="none" (click)="logout()">
            <ion-icon slot="start" name="log-out"></ion-icon>
            <ion-label>
              Logout
            </ion-label>
          </ion-item>
        </ion-list>
        @if (this.env.VERSION !== 'unknown') {
          <ion-item lines="none" style="bottom: 0;position: absolute;">
            <p style="font-size: 1rem">v{{this.env.VERSION}}</p>
          </ion-item>
        }
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
